export const translations = {
  en: {
    lang: 'en', htmlLang: 'en-US',
    siteTitle: 'Live Cam Girls | InstaCamGirls',
    metaDesc: 'Watch live cam girls for free. Chat with sexy camgirls now. 500+ models online.',
    headline: 'Live Cam Girls', subheadline: 'Free chat with sexy girls now',
    liveNow: 'live', girlsOnline: 'girls online',
    watchFree: 'Watch Free', privateShow: 'Private Show',
    joinFree: 'Join Free', joinSub: 'Free • No card required',
    categories: 'Categories', searchPlaceholder: 'Search performers...',
    trending: 'Trending', topRated: 'Top Rated', newGirls: 'New Girls', goldShows: 'Gold Shows',
    noThanks: 'No thanks',
    catLabels: { latina:'Latinas', blonde:'Blondes', brunette:'Brunettes', milf:'MILFs', teen:'Teen (18+)', ebony:'Ebony', asian:'Asian', mature:'Mature' },
    signupHeadline: 'Watch Live Cam Girls', signupSub: 'Free Forever',
    step1Label: 'Enter your email', step2Label: 'Choose a password', step3Label: 'Watch for free — forever!',
    trustSecure: '🔒 SSL Secured', trustVerified: '✅ 18+ Verified', trustMembers: '🌍 300k+ Members', trustRating: '⭐ 4.8/5 Rating',
    push: { title: '🔔 Get notified when your favorites go live!', sub: "We'll alert you when new girls come online. No spam.", allow: 'Yes, notify me!', later: 'Maybe later' },
  },
  fr: {
    lang: 'fr', htmlLang: 'fr-FR',
    siteTitle: 'Filles en Cam Live | InstaCamGirls',
    metaDesc: 'Regardez des filles en cam en direct gratuitement. Chat avec des camgirls sexy maintenant. Plus de 500 modeles en ligne.',
    headline: 'Cam Girls en Direct', subheadline: 'Chat gratuit avec des filles sexy maintenant',
    liveNow: 'en direct', girlsOnline: 'filles en ligne',
    watchFree: 'Regarder Gratuitement', privateShow: 'Show Prive',
    joinFree: "S'inscrire Gratuitement", joinSub: 'Gratuit - Aucune carte requise',
    categories: 'Categories', searchPlaceholder: 'Rechercher des modeles...',
    trending: 'Tendance', topRated: 'Mieux Notees', newGirls: 'Nouvelles Filles', goldShows: 'Gold Shows',
    noThanks: 'Non merci',
    catLabels: { latina:'Latinas', blonde:'Blondes', brunette:'Brunes', milf:'MILFs', teen:'Jeunes (18+)', ebony:'Blacks', asian:'Asiatiques', mature:'Matures' },
    signupHeadline: 'Regardez des Cam Girls en Direct', signupSub: 'Gratuit pour Toujours',
    step1Label: 'Entrez votre email', step2Label: 'Choisissez un mot de passe', step3Label: 'Regardez gratuitement - pour toujours !',
    trustSecure: '🔒 SSL Securise', trustVerified: '✅ +18 Verifies', trustMembers: '🌍 300k+ Membres', trustRating: '⭐ 4.8/5 Note',
    push: { title: '🔔 Sois averti quand tes favorites sont en direct !', sub: 'On t\'alerte quand de nouvelles filles sont en ligne.', allow: 'Oui, me notifier !', later: 'Plus tard' },
  },
  es: {
    lang: 'es', htmlLang: 'es-ES',
    siteTitle: 'Chicas Cam en Vivo | InstaCamGirls',
    metaDesc: 'Mira chicas cam en vivo gratis. Chat con camgirls sexys ahora. Mas de 500 modelos en linea.',
    headline: 'Cam Girls en Vivo', subheadline: 'Chat gratis con chicas sexys ahora',
    liveNow: 'en vivo', girlsOnline: 'chicas en linea',
    watchFree: 'Ver Gratis', privateShow: 'Show Privado',
    joinFree: 'Registrarse Gratis', joinSub: 'Gratis - Sin tarjeta requerida',
    categories: 'Categorias', searchPlaceholder: 'Buscar modelos...',
    trending: 'Tendencia', topRated: 'Mejor Valoradas', newGirls: 'Chicas Nuevas', goldShows: 'Gold Shows',
    noThanks: 'No gracias',
    catLabels: { latina:'Latinas', blonde:'Rubias', brunette:'Morenas', milf:'MILFs', teen:'Jovenes (18+)', ebony:'Negras', asian:'Asiaticas', mature:'Maduras' },
    signupHeadline: 'Mira Cam Girls en Vivo', signupSub: 'Gratis Para Siempre',
    step1Label: 'Ingresa tu email', step2Label: 'Elige una contrasena', step3Label: 'Mira gratis - para siempre!',
    trustSecure: '🔒 SSL Seguro', trustVerified: '✅ +18 Verificado', trustMembers: '🌍 300k+ Miembros', trustRating: '⭐ 4.8/5 Nota',
    push: { title: '🔔 Recibe alertas cuando tus favoritas esten en vivo!', sub: 'Te avisamos cuando nuevas chicas esten en linea.', allow: 'Si, notificame!', later: 'Quizas luego' },
  },
  de: {
    lang: 'de', htmlLang: 'de-DE',
    siteTitle: 'Live Cam Girls - Kostenlos Chatten | InstaCamGirls',
    metaDesc: 'Live Cam Girls kostenlos anschauen. Jetzt mit sexy Camgirls chatten. Uber 500 Models online.',
    headline: 'Live Cam Girls', subheadline: 'Kostenlos mit geilen Girls chatten',
    liveNow: 'live', girlsOnline: 'Girls online',
    watchFree: 'Kostenlos ansehen', privateShow: 'Privat Show',
    joinFree: 'Kostenlos anmelden', joinSub: 'Kostenlos - Keine Kreditkarte nötig',
    categories: 'Kategorien', searchPlaceholder: 'Models suchen...',
    trending: 'Trending', topRated: 'Top Bewertet', newGirls: 'Neue Girls', goldShows: 'Gold Shows',
    noThanks: 'Nein danke',
    catLabels: { latina:'Latinas', blonde:'Blondinen', brunette:'Brunetten', milf:'MILFs', teen:'Teens (18+)', ebony:'Ebony', asian:'Asiatinnen', mature:'Reife Frauen' },
    signupHeadline: 'Live Cam Girls ansehen', signupSub: 'Fur immer kostenlos',
    step1Label: 'E-Mail eingeben', step2Label: 'Passwort wahlen', step3Label: 'Kostenlos schauen - fur immer!',
    trustSecure: '🔒 SSL Gesichert', trustVerified: '✅ 18+ Verifiziert', trustMembers: '🌍 300k+ Mitglieder', trustRating: '⭐ 4.8/5 Bewertung',
    push: { title: '🔔 Benachrichtigung wenn deine Favoriten live sind!', sub: 'Wir informieren dich wenn neue Girls online gehen.', allow: 'Ja, benachrichtigen!', later: 'Vielleicht spater' },
  },
};

export function getLang(searchString) {
  const params = new URLSearchParams(searchString || window.location.search);
  const lg = params.get('lg') || params.get('lang') || '';
  if (['fr','FR'].includes(lg)) return 'fr';
  if (['es','ES'].includes(lg)) return 'es';
  if (['de','DE'].includes(lg)) return 'de';
  if (lg === 'en' || lg === 'EN') return 'en'; // explicit English override
  if (lg) return 'en'; // unknown param, default English

  const langs = navigator.languages || [navigator.language || 'en'];
  for (const l of langs) {
    const code = l.toLowerCase().split('-')[0];
    if (code === 'fr') return 'fr';
    if (['es','pt'].includes(code)) return 'es';
    if (code === 'de') return 'de';
  }
  return 'en';
}

export function getT(searchString) {
  return translations[getLang(searchString)] || translations.en;
}
